import { useMemo, useState } from "react";
import { Container, Tab, Nav, Button } from "react-bootstrap";
import { MainTabSection } from "./userDetailsMyReviewStyle";

import MyReviewsTab from "../../components/common/myReviewsTab";
import FavoriteNonprofits from "../../components/common/favoriteNonprofitsTab";

import { MESSAGE } from "../../utils/message";
import { 
  Route, 
  Routes,
  useNavigate,
  useParams,
} from "react-router-dom";
import MetaComponent from "../../components/common/metaComponent";

const UserDetailsMyReview = () => { 
  const  {user_id} = useParams();
  const [key, setKey] = useState<string>("reviews");
  const navigate = useNavigate();

  const tabsList = useMemo(()=>[
    {
      title: MESSAGE.myReviews,
      key: "reviews",
      path: ``,
    },
    {
      title: MESSAGE.myFavoriteNonprofits,
      key: "favorites",
      path: `favorites`,
    },
 
  ],[user_id]);
  // useEffect(()=> {
  //   if(pathname.includes("user/profile")) {
  //     if (pathname.includes("favorites")) {
  //       setKey("favorites");
  //     } else {
  //       setKey("reviews");
  //     }
  //   }
  // }, [pathname]);

  return (
    <>
    <MetaComponent 
            keywords=""
            description=""
            ogTitle=""
            ogDescription=""
            ogUrl=""
            ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
        />
      <MainTabSection>
      <Container className="cont-w">
        <Tab.Container activeKey={key}>
          <Nav
            className="responsive-tabs nav nav-tabs nav-fill"
          >
            {tabsList?.map((item,index:number) => (
              <Nav.Item key={index+1}>
                <Nav.Link
                  className={key===item.key?"active":""}
                  eventKey={item.key}
                  as={Button}
                  onClick={() => {
                    setKey(item.key);
                    navigate(item.path);
                  }}
                >
                  {item.title}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>

          <Tab.Content>
            <Routes>
              
                <Route path="" Component={MyReviewsTab} />
                <Route path="/favorites" Component={FavoriteNonprofits} />
              
            </Routes>
          </Tab.Content>
        </Tab.Container>
      </Container>
    </MainTabSection>
    </>
    
  );
};
export default UserDetailsMyReview;
